import React from 'react';
import Navbar from "./nav/Navbar";
import './LayoutContainer.css';
import {Container, Row} from "react-bootstrap";
import {useLocation} from "react-router-dom";
import PaperNav from "../themes/PaperNav";
import {useTheme} from "../themes/useTheme";

const LayoutContainer = (props) => {
  const theme = useTheme();
  const {pathname} = useLocation();
  // Paper's home (incl. tag views) has its own title page instead of the running header.
  const paperHome = pathname === '/' || pathname.startsWith('/blog/type/');
  return (
    <Container>
      {theme === 'paper' && !paperHome && <PaperNav/>}
      <Row>
        <Navbar/>
      </Row>
      <Row className="mainContent">
        {props.children}
      </Row>
    </Container>
  );
};

export default LayoutContainer;
